const subscribeInput = document.querySelector(".recharge-subscription input");
const oneTimeInput = document.querySelector(".recharge-one__time input");
const rechargeSubscriptionFieldset = document.querySelector(".recharge-subscription");
const rechargeOneTimeFieldset = document.querySelector(".recharge-one__time");
const rechargeContainer = document.querySelector(".dn-selling-plan-container");
let priceWrapper = document.querySelector(".product-price");

priceWrapper.innerHTML = rechargeContainer.getAttribute("data-price-discount");

subscribeInput.parentNode.addEventListener("click", function (e) {
  if (e.target !== subscribeInput) {
    if (!subscribeInput.checked) {
      subscribeInput.checked = !subscribeInput.checked;
    }
  }
  handleSubscribeInputChange();
});

oneTimeInput.parentNode.addEventListener("click", function (e) {
  if (e.target !== oneTimeInput) {
    if (!oneTimeInput.checked) {
      oneTimeInput.checked = !oneTimeInput.checked;
    }
  }
  handleOneTimeInputChange();
});

subscribeInput.addEventListener("change", handleSubscribeInputChange);
oneTimeInput.addEventListener("change", handleOneTimeInputChange);

function handleSubscribeInputChange() {
  if (subscribeInput.checked) {
    rechargeSubscriptionFieldset.style.borderColor = "#00C7B4";
    rechargeOneTimeFieldset.style.borderColor = "#c0c0c0";
    priceWrapper.innerHTML = rechargeContainer.getAttribute("data-price-discount");
  }
}

function handleOneTimeInputChange() {
  if (oneTimeInput.checked) {
    rechargeOneTimeFieldset.style.borderColor = "#00C7B4";
    rechargeSubscriptionFieldset.style.borderColor = "#c0c0c0";
    priceWrapper.innerHTML = rechargeContainer.getAttribute("data-price-product");
  }
}

// Initial handling of input state
handleSubscribeInputChange();
handleOneTimeInputChange();